<div class="flex flex-row pt-10">
  <!-- Finish button -->
  <insol-flat-button cssClass="ml-4 w-36" [disabled]="!isDirty" [color]="'primary'" (clicked)="onCancel()">
    <span class="ml-2 mr-1">Cancel</span>
  </insol-flat-button>

  <!-- Back button -->
  <insol-flat-button
    cssClass="ml-4 w-36"
    [disabled]="(canBack$ | async) === false"
    [color]="'primary'"
    (clicked)="wizard.previousStep()">
    <mat-icon [svgIcon]="'heroicons_outline:backward'"></mat-icon>
    <span class="ml-2 mr-1">Back</span>
  </insol-flat-button>

  <!-- Next button -->
  <insol-flat-button
    data-cy="nextButton"
    cssClass="ml-4 w-36"
    [disabled]="(canNext$ | async) === false"
    [color]="'primary'"
    (clicked)="wizard.nextStep()">
    <span class="ml-2 mr-1">Next</span>
    <mat-icon [svgIcon]="'heroicons_outline:forward'"></mat-icon>
  </insol-flat-button>

  <!-- Finish button -->
  <insol-flat-button
    data-cy="finishButton"
    cssClass="ml-4 w-36"
    [disabled]="(canFinish$ | async) === false"
    [color]="'primary'"
    (clicked)="onFinish()">
    <span class="ml-2 mr-1">Finish</span>
  </insol-flat-button>
</div>
